import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeliveryTimeByCarrierChartSkeleton = () => (
  <Styles.Container>
    {Array.from({ length: 5 }).map((_, index) => (
      <Styles.Row key={index}>
        <Skeleton variant="text" width={20} height={20} />
        <Styles.BarContainer>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="rounded" width={`${90 - index * 15}%`} height={16} />
        </Styles.BarContainer>
      </Styles.Row>
    ))}
  </Styles.Container>
)

export default DeliveryTimeByCarrierChartSkeleton
